module.exports = __webpack_public_path__ + "img/OmnichannelMarketing.f18504c4.jpg";